export default __webpack_public_path__ + "static/media/About_IMG-Equality.e25dce4b.png";